import Vue from 'vue';
import { LoadingStatus } from '@pjn/core/ui/loading';
import { Store } from '@pjn/vue-core/store';
import { Mutation } from '@pjn/vue-core/store/annotations';

import Notificacion from '@/model/Notificacion';
import { alertaApi } from '@/api';
import Alerta from '@/model/Alerta';
import { configuracionStore } from '.';

/**
 * Store que consulta y actualiza magistrados
 */
@Store
export default class NotificacionesStore extends Vue {
  notificaciones: Notificacion[] = [] as unknown[] as Notificacion[]
  alerta: Alerta | null = null

  /** Estado de carga de (para mostrar loader). */
  status: LoadingStatus = {};

  /**
   * Realiza la consulta del estudio asociado a la persona
   */
 


  async load() {
    this.beginRequest();

    try {
      const notificaciones = [
  ] as unknown[] as  Notificacion[]
      this.alerta = await alertaApi.get()
      if (this.alerta?.porVencer) notificaciones.push({ title: 'Hay denuncias por vencer', url: 'denuncias/porVencer' })
      if (this.alerta?.vencidas) notificaciones.push({ title: 'Hay denuncias vencidas', url: 'denuncias/vencidas' })
      configuracionStore.updateSuccess(this.alerta.configuracion)
      this.loadSuccess(notificaciones)
      return this.notificaciones
    } catch (e) {
      this.loadFail();
     return  Promise.reject("Error cargando notificaciones") ;
    }
  }

    async reload() {
  return true
  }



  async delete(index: number) {
    const notificaciones = this.notificaciones

    notificaciones.splice(index, 1)
    this.updateSuccess(notificaciones)

   
}
 
 
  @Mutation
  private beginRequest() {
    this.status = { loading: true };
  }

  @Mutation
  private loadSuccess(notificaciones: Notificacion[]) {
    this.status = {};
    this.notificaciones = notificaciones;
  }

  @Mutation
  private updateSuccess(notificaciones: Notificacion[]) {
    this.notificaciones = notificaciones;

    return true;
  }
 

  @Mutation
  private loadFail() {
    this.status = { error: true };
    this.notificaciones = [];
  }

  @Mutation
  private fail() {
    this.status = { error: true };
  }
}
